import notify, { Toaster } from "react-hot-toast";

export const Toast = () => {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 5000,
        removeDelay: 1000,
      }}
    />
  );
};

export const makeSuccessToast = ({ message = "Success" }) => {
  notify.success(message);
};

export const makeErrorToast = ({ message = "An unexpected error occured" }) => {
  notify.error(message);
};

export const makeToast = ({ message = "" }) => {
  notify(message);
};
